import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('datePicker');

    return {
        CLEAR: t('clear'),
        SELECT_DATE: t('selectDate')
    };
};

export default useTranslation;
